import * as Icons from "react-icons/hi";
interface InputProps {
  label: string;
  name: string;
  type?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hasLabel?: boolean;
  placeHolder?: string;
  options: Array<{
    label?: string | number | readonly string[] | undefined;
    value?: string | number | readonly string[] | undefined;
    name?: string;
    id?: string | number;
  }>;
  icon?: {
    iconName: string;
    color?: string;
    size?: number;
  };
  onChange: (value: any) => void;
  data?: any;
  noDefault?: boolean;
  onKeyDown?: (event: any) => void;
}

const SelectInput = (props: InputProps) => {
  const n = props.icon?.iconName ?? "";
  const IconComponent = (Icons as any)[n];
  const handleChange = (e: any) => {
    props.onChange(e.target.value);
  };


  // const options = props.data ? props.options.filter(x => x.id !== props.data.id) : props.options;
  return (
    <div
      className={`flex flex-col ${
        props.hasLabel && "space-y-2"
      } w-[100%] relative my-3`}
    >
      {props.hasLabel && (
        <label className="text-xl">
          {props.label}{" "}
          <span className="text-red-600">{props.required ? "*" : ""}</span>
        </label>
      )}
      <span className="absolute bottom-3 left-4">
        {props.icon === undefined || props.icon === null ? null : (
          <IconComponent size={props.icon.size} color={props.icon.color} />
        )}
      </span>
      <select
        onKeyDown={props.onKeyDown}
        className="border-[1px] py-2 px-4 rounded-md h-16 text-lg"
        onChange={handleChange}
        defaultValue={props.data ? props.data : null}
      >
        {props.noDefault !== true ? (
          <option key={0} value={props.data ? props.data : ""}>
            {props.data
              ? props.options.find(
                  (x) => x.id === props.data
                )?.name ||
                props.options.find(
                  (x) => x.value === props.data.toString()
                )?.label
              : `Select ${props.label.toLowerCase()}`}
          </option>
        ) : null}
        {props.options.map((option, idx) => (
          <option key={idx} value={option.id || option.value}>
            {option.name || option.label}
          </option>
        ))}
      </select>
      {/* <input placeholder={props.placeHolder} type={props.type} name={props.name} className={`h-14 md:h-16 border-[1px] px-4 py-2 rounded-md border-[#E4E4E7] ${props.icon !== undefined || props.icon !== null ? "pl-14" : ""} ${props.className}`} disabled={props.disabled} required={props.required}/> */}
    </div>
  );
};

export default SelectInput;
